﻿import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { SessionService } from '../services/session.service';

@Directive({
    selector: '[hasWritePermission]'
})

export class WritePermissionDirective {
    @Input('hasWritePermission') featureId: string;
    userPermissions: any;
    constructor(private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,private sessionService:SessionService) {
        this.userPermissions = JSON.parse(this.sessionService.getItem('userPermissions'));
    }
    ngOnInit() {
        this.setWritePermissions();
    }

    setWritePermissions() {
        var features = this.userPermissions.filter(x => x.FeatureId.toUpperCase() === this.featureId);
        if(features.length > 0){
        var writePermission = features[0].WriteAccess;
        if (writePermission) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainer.clear();
        }
        }else
        {
            this.viewContainer.clear();
        }
       
    }
}
